module.exports = __webpack_public_path__ + "static/media/cubes-solid.25cbc2e7.svg";